import { IReleaseNote } from "../types"

export const RELEASE_1_4_8: IReleaseNote = {
    status: "PAST",
    title: "v1.4.8",
    date: "24th October 2024",
    releaseType: "Patch",
    notesBodyAllUsers: [
        {
            heading: "Introduction",
            content:
                "Patch 1.4.8 refines the clarity of certain statements within specific sections of the platform. These targeted changes are minimal, not visible to all users, and have no impact on overall functionality. ",
        },
    ],
    notesBodyInstaller: [
        {
            heading: "For installers using the web portal",
            content: "This release contains no changes to your functionality",
        },
        {
            heading: "For installers using our APIs",
            content: "This release contains no changes to your functionality",
        },
    ],
    notesBodyDno: [
        {
            heading: "For DNOs using the web portal",
            content: "The following change has been been added:",
            bullets: [
                "It was brought to our attention that the statements 'Installer says supply has no issues?' and 'No Safety Concerns?' in the 'Supply Details' section were causing some confusion. To improve clarity, we’ve updated the wording. ",
            ],
        },
        {
            heading: "For DNOs using our APIs",
            content: "This release contains no changes to your functionality",
        },
    ],
    notesBodyManu: [
        {
            heading: "For manufacturers using the web portal",
            content: "This release contains no changes to your functionality",
        },
    ],
    notesBodyDbAssessorDemand: [
        {
            heading: "For demand evaluators using the web portal",
            content: "This release contains no changes to your functionality",
        },
    ],
    notesBodyDbAssessorGen: [
        {
            heading: "For generation evaluators using the web portal",
            content: "This release contains no changes to your functionality",
        },
    ],
}
